import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";


interface SendContactUsDTO {
    name: string;
    email: string;
    message: string;
    phone: string;
}

interface ContactUsResponse extends ApiError {
    id: string;
    email: string;
    name: string;
    message: string;
    phone: string;
    createdAt: string;
    updatedAt: string;
}
export const SendContactUs = (data: SendContactUsDTO): Promise<ContactUsResponse> => {
    return axios.post("/contact-us/create", data)
        .then(response => response.data as ContactUsResponse);
};